export var ProductCardElevation;
(function (ProductCardElevation) {
    ProductCardElevation[ProductCardElevation["None"] = 0] = "None";
    ProductCardElevation[ProductCardElevation["Small"] = 10] = "Small";
    ProductCardElevation[ProductCardElevation["Medium"] = 20] = "Medium";
    ProductCardElevation[ProductCardElevation["Large"] = 30] = "Large";
    ProductCardElevation[ProductCardElevation["XL"] = 40] = "XL";
})(ProductCardElevation || (ProductCardElevation = {}));
//# sourceMappingURL=ProductCard.types.js.map